const IP_REGEX = /ip=(?<ip>.*)/;
const TRACE_URL = "https://www.cloudflare.com/cdn-cgi/trace";

function text(url: string): Promise<string> {
  return fetch(url).then((res) => res.text());
}

export const getIP = (): Promise<string> => {
  return text(TRACE_URL).then((data) => {
    const match = IP_REGEX.exec(data);
    return match?.groups?.ip ?? "";
  });
};
